import { MenuItem } from '@amobee/component-library/dist/'; // Import React Component for testing
import { registerElement } from '@angular-react/core'; // Use 'registerElement' to register the element for testing
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MenuItemComponent } from './menu-item.component';

const components = [MenuItemComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components, // When testing, add the test component to declarations
    exports: components, // When testing, add the test component to exports
    schemas: [NO_ERRORS_SCHEMA]
})
export class ReactComponentsModule {
    constructor() {
        registerElement('MenuItem', () => MenuItem);
    }
}
